{
  "addButtonLabel": "操作或手术",
  "date": "日期",
  "datePlaceholder": "e.g. June 2022, 2021, or ~5 years ago",
  "location": "地点",
  "locationPlaceholder": "e.g. Ormiston Hospital, Auckland",
  "nextLabel": "$t(common:next): <b>行动能力</b>",
  "procedure": "手术或治疗的描述",
  "procedurePlaceholder": "请用英文填写。例如: <br/>\nColonoscopy to investigate bleeding",
  "saveButton": "保存手术信息",
  "text": "<p>我们记录了您在 {{company}} 的上一次内窥镜检查：</p>\n<ul><li><strong>{{procedure}}</strong> 于 <strong>{{date}}</strong></li></ul>\n<p>自那以后，您是否做过其他内窥镜检查、腹部手术或大型手术？</p>",
  "textNoProcedure": "您过去做过内窥镜检查、腹部手术或大型手术吗？",
  "title": "最近的手术或治疗程序"
}
